export const POWERED_BY_SIRONA_CLASSIFICATIONS = 'Powered by Sirona Intelligent Classifications';

export const SNACKBAR_CONTENT_PROPS = { reduceCloseButtonHeight: true } as const;

export const HP_MODAL_VARIANTS = Object.freeze({
  SAVE: 'save',
  UPDATE: 'update',
  DELETE: 'delete',
  SEARCH: 'search',
});

export type WidgetMode = (typeof HP_MODAL_VARIANTS)[keyof typeof HP_MODAL_VARIANTS] | null;

export const SUBMIT_FORM_INTENT = Object.freeze({
  SAVE: HP_MODAL_VARIANTS.SAVE,
  UPDATE: HP_MODAL_VARIANTS.UPDATE,
});

export type SubmitFormIntent = (typeof SUBMIT_FORM_INTENT)[keyof typeof SUBMIT_FORM_INTENT];

export const HANGING_PROTOCOL_PHASE = Object.freeze({
  TWO: 'phase-2',
  THREE: 'phase-3',
  FOUR: 'phase-4',
  FOUR_STEPS: 'phase-4-steps',
  FIVE: 'phase-5',
});

export type HangingProtocolPhase =
  (typeof HANGING_PROTOCOL_PHASE)[keyof typeof HANGING_PROTOCOL_PHASE];

// Stepped HP has a hard dependency on phase-4 behavior (V4 form, viewport classifications, etc.),
// so `phase-4-steps` is treated as a superset of `phase-4` everywhere phase-4 gates UI/behavior.
export function isAtLeastPhase4(phase: string | undefined): boolean {
  return phase === HANGING_PROTOCOL_PHASE.FOUR || phase === HANGING_PROTOCOL_PHASE.FOUR_STEPS;
}

export function isPhase4Steps(phase: string | undefined): boolean {
  return phase === HANGING_PROTOCOL_PHASE.FOUR_STEPS;
}
